
    import { Component, Vue } from 'vue-property-decorator';
    import InputText from '@/components/form/Input-text.vue';
    import {ApiRepository} from '@/api';


    @Component({
        components: {
            InputText,
        },
    })
    export default class ResetPassword extends Vue {
        private email = '';

        private async onSubmit(event: any) {
            event.preventDefault();

            await ApiRepository.postResetPassword(this.email);
        }
    }
